export default __webpack_public_path__ + "static/media/gift6.039ddc7c.png";